export const REQUEST = 'AUTH_LOGOUT_REQUEST';
export const SUCCESS = 'AUTH_LOGOUT_SUCCESS';
export const FAILURE = 'AUTH_LOGOUT_FAILURE';

export const fetchRequest = () => ({
  type: REQUEST
});

export const fetchSuccess = () => ({
  type: SUCCESS
});

export const fetchFailure = (error) => ({
  type: FAILURE,
  payload: error
});
